import React, { useState, useEffect } from 'react';

import GenericInputContainer from '../shared/GenericInputContainer';
import DisplayItemList from './DisplayItemList';
import EditItemList from './EditItemList';

const ItemListInputContainer = ({
    iconName,
    initialValue: onPageLoadInitialItems,
    syncChanges,
    getSuggestions,
    isEditing,
    setIsEditing,
    isHovered,
    isCreationPermitted,
}) => {
    const [items, setItems] = useState(Array.isArray(onPageLoadInitialItems) ? [...onPageLoadInitialItems] : []);
    const [initialItems, setInitialItems] = useState(Array.isArray(onPageLoadInitialItems) ? [...onPageLoadInitialItems] : []);

    useEffect(() => {
        setItems(Array.isArray(onPageLoadInitialItems) ? [...onPageLoadInitialItems] : []);
        setInitialItems(Array.isArray(onPageLoadInitialItems) ? [...onPageLoadInitialItems] : []);
    }, [onPageLoadInitialItems]);

    const isFieldNull = !items.length;

    const valueHasntChanged = () => {
        if (items.length === 0 || initialItems.length === 0) {
            return items.length === initialItems.length;
        }
        return items.every((i) => initialItems.some((ii) => i.id === ii.id)) && 
                initialItems.every((i) => items.some((ii) => i.id === ii.id));
    };

    const handleSave = async () => {
        const response = await syncChanges(items);
        if (response.success) {
            setItems(response.value && response.value.length ? response.value : []);
            setInitialItems(response.value && response.value.length ? response.value : []);
        }
        return response;
    };

    const handleCancel = () => {
        setItems([...initialItems]);
    };

    return (
        <GenericInputContainer {...{ isEditing, setIsEditing, isHovered, isFieldNull, handleSave, handleCancel, valueHasntChanged }}>
            <DisplayItemList {...{ items }} />
            <EditItemList {...{ iconName, value: items, setValue: setItems, getSuggestions, isCreationPermitted }} />
        </GenericInputContainer>
    );
};

export default ItemListInputContainer;
